module.exports = __webpack_public_path__ + "img/dp8.efae6348.jpeg";